import { withoutNullable } from "@syla/shared/types/helpers/withoutNullable";
import {
  getWalletName,
  PopulatedWallet,
} from "@syla/shared/types/models/WalletBase";
import { StandardSelectOption } from "../../components/selector/parts/SelectOption";
import noPaddingMissingImageIcon from "../../images/thumbnails/noPaddingMissingImageIcon.svg";
import { useGetWallets } from "../../store/actions/wallet";

export const useGetWalletOptions = (accountId: string) =>
  useGetWallets(accountId, undefined, {
    select: (data) => data.wallets.map(formatWalletOption),
  });

export const formatWalletOption = (
  wallet: Pick<PopulatedWallet, "_id" | "customName" | "dataSource">,
): StandardSelectOption => {
  const label = getWalletName({ wallet, dataSource: wallet.dataSource });
  const keywords = withoutNullable([
    // no need to also include the label as it's already one of the below
    wallet.customName,
    wallet.dataSource.name,
    ...(wallet.dataSource.aliases ?? []),
  ]);

  return {
    value: wallet._id,
    keywords,
    data: {
      label,
      icon: wallet.dataSource.image ?? noPaddingMissingImageIcon,
    },
  };
};
